import EventAgent from '@hotmart-org-ca/event-agent-js';

const isDev = process.env.NODE_ENV === 'development';
const debugServerUrl = process.env.DEBUG_SERVER_URL || 'http://localhost:3003/events';
const debugEnabled = process.env.DEBUG_EVENTS !== 'false';

const originalSend = EventAgent.send.bind(EventAgent);

EventAgent.send = async (eventData: any) => {
  if (isDev && debugEnabled) {
    try {
      await fetch(debugServerUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...eventData,
          timestamp: new Date().toISOString(),
          environment: 'development',
        }),
      });

      console.log(
        '%c[Event Debug]',
        'color: #4CAF50; font-weight: bold',
        'Event sent to debug server:',
        eventData
      );

      return Promise.resolve();
    } catch (error) {
      console.error(
        '%c[Event Debug]',
        'color: #f44336; font-weight: bold',
        'Failed to send to debug server:',
        error
      );

      return Promise.reject(error);
    }
  }

  return originalSend(eventData);
};

export default EventAgent;
